
const subpropertyStatus = {
  ENABLE: 'enabled',
  DISABLE: 'disabled',
}

export function subpropertyStatusColor(status){
  if (!status || status === subpropertyStatus.ENABLE) {
    return '#67C23A'
  }
  if (!status || status === subpropertyStatus.DISABLE) {
    return '#F56C6C'
  }
}
export function subpropertyStatusTagType(status){
  if (!status || status === subpropertyStatus.ENABLE) {
    return 'success'
  }
  if (!status || status === subpropertyStatus.DISABLE) {
    return 'danger'
  }
}
export default subpropertyStatus;